module.exports = __webpack_public_path__ + "img/enterprise-road-3.df3215f7.png";